document.getElementById("year").innerHTML = (new Date().getFullYear());
document.getElementById("build-time").innerHTML = process.env.BUILD_TIME;

/* ***** ----------------------------------------------- ***** **
/* ***** Lottie Player
/* ***** ----------------------------------------------- ***** */

import "@lottiefiles/lottie-player";
